module.exports = __webpack_public_path__ + "static/media/26.1be24653.jpg";